import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

/**
 * Component breadcrumb navigation cho trang danh sách tuyển dụng
 */
function JobNav() {
    const {locale} = useRouter();
    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.recruitment.nav_title') || 'TUYỂN DỤNG',
                        href: '/tuyen-dung',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default JobNav;
